import e from"react";import{Toaster as t}from"react-hot-toast";const r=({position:r="top-center",reverseOrder:o=!1,duration:a=3e3,...n})=>e.createElement(e.Fragment,null,e.createElement(t,{position:r,reverseOrder:o,toastOptions:{duration:a},...n}));export{r as Toaster};
//# sourceMappingURL=Toaster.js.map
